export default __webpack_public_path__ + "locales/zh-CN/InviteDialog.json?hash=9bd37fee4271b01bb38e92105240dbc5";